import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";

export default class APIDaily extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getDateParam = async (
    dateParam: string,
    { orderType }: { orderType?: "sale" | "purchase" | null } = {},
  ): Promise<types.OrderResponse[]> => {
    let res = await this._fetch({
      url: `/orders/daily/${dateParam}`,
      method: "GET",
      params: { order_type: orderType },
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
